import useNotificationPlacementSetting from 'src/hooks/useNotificationPlacementSetting';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { hideNotification } from 'src/utils/notifications';
import { DriftTheme } from '../../environmentVariables/EnvironmentVariables';
import useDriftTheme from '../../hooks/useDriftTheme';
import AuctionAlert from './AuctionAlert';
import Notification from './Notification';

const ToastList = () => {
	const notifications = useDriftStore((s) => s.notifications);
	const driftStatus = useDriftStore((s) => s.driftStatus.mainStatus);
	const setDriftStore = useDriftStore((s) => s.set);

	const [notificationSelection] = useNotificationPlacementSetting();

	const hide = (notificationId?: string) => {
		hideNotification(setDriftStore, notificationId);
	};

	const notificationPositionStyles =
		notificationSelection === 'bottomLeft'
			? 'bottom-0 left-0'
			: notificationSelection === 'bottomRight'
			? 'bottom-0 right-0'
			: 'top-0 right-0';

	const notificationsToUse = notifications.filter((notification) => {
		return !notification.hidden;
	});

	const isDark = useDriftTheme() === DriftTheme.dark;

	if (notificationsToUse.length === 0) return null;

	return (
		<div
			className={`fixed xs:w-full sm:w-auto flex flex-col p-2 ${notificationPositionStyles}`}
			style={{
				boxShadow: `0px 0px 20px 20px rgba(${
					isDark ? '10,10,10' : '235,235,235'
				},0.35)`,
				zIndex: 200,
				backgroundColor: `rgba(${isDark ? '10,10,10' : '235,235,235'},0.35)`,
			}}
		>
			<div className={`flex flex-col w-full space-y-4`}>
				{notifications
					.filter((n) => !n.hidden)
					.map((n, idx) => (
						<span key={idx}>
							{n.type === 'auction' ? (
								<AuctionAlert
									auction={n.auctionState}
									onClose={() => {
										hide(n.id);
									}}
								/>
							) : (
								<Notification
									key={`${n.startTimeMs}`}
									notificationData={n}
									index={notifications.length - 1 - idx}
									statusWarning={driftStatus.message}
									statusType={driftStatus.status}
								/>
							)}
						</span>
					))}
			</div>
		</div>
		// </div>
	);
};

export default ToastList;
